// determine host name dynamically (safe as oauth2 client has authorised whitelist)
let hostName = 'https://www.panessex.co.uk';
if (process.browser) {
  const { location } = window.document;
  hostName = `${location.protocol}//${location.host}`;
}

// oidc config
export default {
  authority: 'https://login.vigilantapps.com',
  client_id: 'panessex-reportingui',
  response_type: 'id_token token',
  scope: 'openid profile vipro-identity ReportingApi offline_access',
  // post log-on redirect
  redirect_uri: `${hostName}/signin-oidc`,
  // silent renewal
  automaticSilentRenew: true,
  silent_redirect_uri: `${hostName}/silent-refresh-oidc.html`,
  accessTokenExpiringNotificationTime: 45
}
